// extracted by mini-css-extract-plugin
export default {"conatiner":"_dharrt","carousel-container":"_6ainya","carouselContainer":"_6ainya","carousel":"_1at50em"};